import React, { useEffect, useState } from 'react';
import { getPriceWithCurrency } from '../../utils/helpers';
import styles from './ModernCrossSells.module.sass';

export default function ModernCrossSell({ crossSell, onChange, offers, offer }) {
  const hasVariants = crossSell.variants.length > 0;
  const [selectedVariant, setSelectedVariant] = useState(null);
  const currentItem = hasVariants ? { ...crossSell, ...selectedVariant } : crossSell;

  useEffect(() => {
    if (hasVariants) {
      setSelectedVariant(crossSell.variants[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function handleSelectVariant(e) {
    const value = crossSell.variants.find((item) => item.productId === e.target.value);
    setSelectedVariant(value);
  }

  function handleAdd() {
    onChange(currentItem);
  }

  const active = offers.find((item) => item.product_id === currentItem.productId);
  const isDisabled = crossSell.disabled && active;

  const handleClick = () => {
    if (!isDisabled) {
      handleAdd();
    }
  };

  return (
    <div className={`${styles.card} ${active ? styles.cardActive : ''}`}>
      <div className={styles.badge}>{currentItem.discount}% OFF</div>
      {currentItem.stock && (
        <div className={styles.stockBadge}>
          <i className='fas fa-exclamation-triangle'></i> {currentItem.stock}
        </div>
      )}

      <div className={styles.imageContainer}>
        <img src={selectedVariant?.productImg || currentItem.imageSrc} alt={currentItem.name} />
      </div>

      <div className={styles.content}>
        <div className={styles.titleRow}>
          <h4>{selectedVariant?.productName || currentItem.title || currentItem.name}</h4>
          <div className={styles.priceBlock}>
            <span className={styles.oldPrice}>
              {getPriceWithCurrency(currentItem.msrp, offer?.locale, offer?.currency)}
            </span>
            <span className={styles.newPrice}>
              {getPriceWithCurrency(currentItem.price, offer?.locale, offer?.currency)}
            </span>
          </div>
        </div>

        <ul className={styles.benefits}>
          {currentItem.benefits.map((benefit, index) => (
            <li key={index}>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                fill='none'
                viewBox='0 0 24 24'
                strokeWidth={2}
                stroke='currentColor'
              >
                <path strokeLinecap='round' strokeLinejoin='round' d='M4.5 12.75l6 6 9-13.5' />
              </svg>
              {benefit}
            </li>
          ))}
        </ul>

        <div className={styles.controls}>
          {hasVariants && (
            <select
              className={styles.variantSelect}
              onChange={handleSelectVariant}
              value={selectedVariant?.productId}
            >
              {currentItem.variants.map((item, index) => (
                <option key={index} value={item.productId}>
                  {item.value}
                </option>
              ))}
            </select>
          )}

          <button
            className={`${styles.addButton} ${active ? styles.removeButton : ''}`}
            onClick={handleClick}
            disabled={isDisabled}
          >
            {active ? 'Remove' : 'Add to Order'}
          </button>
        </div>
      </div>
    </div>
  );
}
